import gql from 'graphql-tag'

const clientiNewsletterSearch = gql`
  query clientiNewsletterSearch($search: String, $limit: Int!, $offset: Int, $where: ClientiFilterInput, $orderBy: [ClientiOrderBy]) {
    clientiNewsletterSearch(search: $search, limit: $limit, offset: $offset, where: $where, orderBy: $orderBy) {
      nome
      email
      telefono
    }
  }
`

export default clientiNewsletterSearch



// WEBPACK FOOTER //
// ./src/graphql/queries/clientiNewsletterSearch.js